import * as React from "react";
import { CssBaseline } from "@mui/material";
import { useClinicData } from "../clinic/clinicHooks";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]
// TODO: opt in override, only for helix
const DONT_OVERRIDE_CSS_CLINIC_IDS = [
  "0f6d3d55-c11b-4e11-b257-b54b511908e7", // Default-dev
  "19413d3f-b29f-4a30-9b17-64492a27320c", // VitelNet
  "d76e500b-da75-4b8f-bdeb-cc5dfaa8c327", // VitelNet - DEV
];

export interface OverriderCssBaselineProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const OverriderCssBaselineBasedOnClinic = ({
  ...props
}: OverriderCssBaselineProps) => {
  const { clinic: clinicId } = useClinicData();

  if (
    DONT_OVERRIDE_CSS_CLINIC_IDS.some((disabledIds) => disabledIds === clinicId)
  )
    return null;
  return <CssBaseline />;
};
